import { Button, Menu, MenuItem, Position } from '@blueprintjs/core';
import { Popover2 } from '@blueprintjs/popover2';
import { IconNames } from '@blueprintjs/icons';
import { useNavigate } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { DonorInfoFragment, useDeleteDonorMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type DonorDetailMenuProps = {
  donor: DonorInfoFragment;
  onEdit: () => void;
};

const DonorDetailMenu = ({ donor, onEdit }: DonorDetailMenuProps) => {
  const navigate = useNavigate();
  const [deleteDonor, { loading: deleting }] = useDeleteDonorMutation({
    variables: {
      id: donor.id,
    },
    onCompleted: () => {
      AppToaster.success(`${donor.name}  wurde in den Papierkorb gelegt`);
      navigate(-1);
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover2
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteDonor as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover2>
    </>
  );
};

export default DonorDetailMenu;
